
angular
	.module('servicepro.daterangewidget', [
		'ngResource'
	]);

